import { useContext } from 'react'
import Menu from './Menu'
import { Article as ArticleIcon, Calculate as CalculateIcon, People as PeopleIcon, Restaurant as RestaurantIcon } from '@mui/icons-material'
import MenuItem from './MenuItem'
import AmericanFlagIcon from '../img/flag-usa'
import CanadianFlagIcon from '../img/flag-canada'
import MenuDivider from './MenuDivider'
import { ROLES } from '../auth/role'
import RoleContext from '../auth/RoleContext'

export default function SidebarMenu(props = {}) {
  window.scrollTo(0, 0)
  const roleDetails = useContext(RoleContext)

  return (
    <Menu>
      <MenuItem href="#" title="Label Declaration Sheets" defaultOpen = {false} icon={<ArticleIcon /> } >
        <MenuItem href="/label-declaration-sheets/regulation/2" title=" United States" icon={ <AmericanFlagIcon/> } />
        <MenuItem href="/label-declaration-sheets/regulation/4" title=" Canada" icon={ <CanadianFlagIcon/> } />
      </MenuItem>
      {roleDetails.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN, ROLES.SRA_USER]) &&
        <>
          <MenuItem href="http://nutrition-calculator.test.tis.coke.com" target="_blank" title="Nutrition Calculator" icon={<CalculateIcon />} />
          <MenuItem href="/genesis" title="Genesis" icon={<RestaurantIcon />} />
        </>
      }
      {roleDetails.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) &&
        <>
          <MenuDivider />
          <MenuItem href="/users/list/" title="User Management" icon={<PeopleIcon />} />
        </>
      }
    </Menu>
  )
}
